























































   
 
	import { userService }  from '@/servicegerente';

	import { Component, Vue } from 'vue-property-decorator'; 
	  
	@Component({
		components: {  },
	 })
    export default class Apple extends Vue {

		public assinatura: any = null; 
		public dados: any = null; 
		 
		public urlRetorno: any= '/v2/administracao/configuracao';
  
        verifyAssinaturaApple() { 
            window.alertProcessando();  
            userService.verifyAssinaturaApple( this.assinatura )
            .then(response => {
                window.alertProcessandoHide(); 
                this.dados = response;
            })
            .catch(error => {  
                window.alertProcessandoHide(); 
                console.log(error);
                window.toastErro('Não foi possivel adiciona ' , error.data.message); 
            });   
        } 


        getTransactionHistory() { 
            window.alertProcessando();  
            userService.getTransactionHistory( this.assinatura )
            .then(response => {
                window.alertProcessandoHide(); 
                this.dados = response;
            })
            .catch(error => {  
                window.alertProcessandoHide(); 
                console.log(error);
                window.toastErro('Não foi possivel adiciona ' , error.data.message); 
            });   
        } 

        getTransactions() { 
            window.alertProcessando();  
            userService.getTransactions( this.assinatura )
            .then(response => {
                window.alertProcessandoHide(); 
                this.dados = response;
            })
            .catch(error => {  
                window.alertProcessandoHide(); 
                console.log(error);
                window.toastErro('Não foi possivel adiciona ' , error.data.message); 
            });   
        } 

        getLookup() { 
            window.alertProcessando();  
            userService.getLookup( this.assinatura )
            .then(response => {
                window.alertProcessandoHide(); 
                this.dados = response;
            })
            .catch(error => {  
                window.alertProcessandoHide(); 
                console.log(error);
                window.toastErro('Não foi possivel adiciona ' , error.data.message); 
            });   
        } 

        getRefundLookup() { 
            window.alertProcessando();  
            userService.getRefundLookup( this.assinatura )
            .then(response => {
                window.alertProcessandoHide(); 
                this.dados = response;
            })
            .catch(error => {  
                window.alertProcessandoHide(); 
                console.log(error);
                window.toastErro('Não foi possivel adiciona ' , error.data.message); 
            });   
        } 
 
	}
 
